import { gql } from '@apollo/client';

export const GET_AD_TYPES = gql`
  query GET_AD_TYPES {
    getAdTypesV5
  }
`;
